import React from "react";
import homePageImage from "./homePageMainImage.jpg";
import SearchBar from "../SearchBar";

// Display banner on Home Page screen.
const HomePageBanner = () => {
    return (
    <div className="row pb-5 ms-4 ">
        <div className="wd-image-stack">
            <div className= "wd-image-stack-item-bottom ">
                <img src = {homePageImage} alt="homePageBanner" className="img-fluid wd-banner-pic"/>
            </div>
            <div className="wd-image-stack-item-top-home m-0">
                <span>Food Mafia</span>
                <div>
                    <h1>Discover the best food and drinks</h1>
                </div>
            </div>
            <div className={"d-flex"}>
                <div className="mx-5">
                </div>
                <div className="wd-search-bar">
                    <SearchBar/>
                </div>
                <div className="mx-5">
                </div>
            </div>
        </div>
    </div>
    )
}

export default HomePageBanner;